import React, { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import {
  TABLE_HEAD_VARIANTS,
  TableHeadVariantsType,
} from "~/common/types/tableTypes";

interface TableHeadProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLTableSectionElement> {
  className?: string;
  variants?: TableHeadVariantsType;
}

export const TableHead = ({
  children,
  className,
  variants = TABLE_HEAD_VARIANTS.blue_head,
  ...props
}: TableHeadProps) => {
  return (
    <thead
      className={twMerge(
        "h-fit w-full border-b border-gray-200 text-left text-sm",
        variants === TABLE_HEAD_VARIANTS.white_head &&
          "bg-neutral-50 text-gray-10",
        variants === TABLE_HEAD_VARIANTS.blue_head &&
          "bg-primary-50 text-primary-900",
        className,
      )}
      {...props}
    >
      {children}
    </thead>
  );
};
